import { AddressInfoDto, PlacesAutocompleteOption } from '../interfaces';

interface Response<TData> {
	data: TData;
}

export interface IPGeolocation {
	ipVersion: number;
	ipAddress: string;
	latitude: number;
	longitude: number;
	countryCode: string;
	countryName: string;
	timeZone: string;
	timeZones: string[];
	regionName: string;
	cityName: string;
	continentCode: string;
	continent: string;
	zipCode: string;
	currency: {
		code: string;
		name: string;
	};
	language: string;
	tlds: string[];
	isProxy: boolean;
}

export class GeolocationService {
	constructor(private readonly httpClient: any) {}

	public async getNavigatorGeolocation(): Promise<GeolocationPosition> {
		return new Promise((resolve, reject) => {
			navigator.geolocation.getCurrentPosition(resolve, reject);
		});
	}

	public async getGeolocation(): Promise<GeolocationPosition> {
		return this.getNavigatorGeolocation();
	}

	public async getIPGeolocation<T = IPGeolocation, R extends Response<T> = Response<T>>(): Promise<R> {
		return this.httpClient.get('/api/json', {
			baseURL: 'https://freeipapi.com',
			headers: {
				Authorization: undefined,
			},
		});
	}

	public getAddressInfoFromIPGeolocation(ipGeolocation: IPGeolocation): AddressInfoDto {
		const fullAddress = `${ipGeolocation.cityName}, ${ipGeolocation.regionName}, ${ipGeolocation.countryName}, ${ipGeolocation.zipCode}`;

		return {
			name: fullAddress,
			city: ipGeolocation.cityName,
			country: ipGeolocation.countryName,
			lat: ipGeolocation.latitude,
			lng: ipGeolocation.longitude,
			state: ipGeolocation.regionName,
		};
	}

	public getPlaceAutocompleteFromIPGeolocation(ipGeolocation: IPGeolocation): PlacesAutocompleteOption {
		const fullAddress = `${ipGeolocation.cityName}, ${ipGeolocation.regionName}, ${ipGeolocation.countryName}, ${ipGeolocation.zipCode}`;

		return {
			id: `${ipGeolocation.latitude}-${ipGeolocation.longitude}`,
			description: fullAddress,
			formattedSuggestion: {
				mainText: ipGeolocation.cityName,
				secondaryText: `${ipGeolocation.regionName}, ${ipGeolocation.countryName}`,
			},
		};
	}
}
